var _CustomComponent;
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * DomElement type from @types/domhandler
 */

/**
 * The context for a transformation of custom components to React.
 * Note: these will need to be passed into appropriate function parameters
 * For example `parseCustomMarkdownToReact(someHtml, context)`
 * - where context: ProcessNodeContext
 */

/**
 * A custom component type, e.g. `<chart>`.
 */
export default class CustomComponent {
  /**
   * Gets the name of the DOM element for this custom component. For example,
   * if this custom component is derived from a `<chart>` tag, the name property's
   * value would be `"chart"`.
   */

  /**
   * Gets the custom attributes for this tag, eg. ["src-preview"].
   * Used so that when the user-supplied html is sanitized, these attributes are not stripped.
   */

  /**
   * Determine if a given DOM node should be processed by this component. By
   * default, this method returns `true` if the node name matches the
   * {@link CustomComponent#name} property. If this method returns `true`,
   * {@link CustomComponent#processNode} will be called.
   *
   * @param context The context for the custom component
   * @param node The node that should possibly be processed.
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  shouldProcessNode(context, node) {
    return this.name === node.name;
  }

  /**
   * Transforms a DOM element into a React element. This function is passed to
   * to html-to-react's `processingInstructions`.
   *
   * @param context Context for the custom component.
   * @param node The DOM node to transformed to React.
   * @param children The already-transformed React elements that are this node's children.
   * @param index The index of this node in its parent's list of children.
   */

  /**
   * Registers a custom component.
   * @param component The component to register.
   */
  static register(component) {
    this._types.set(component.name, component);
  }

  /**
   * Unregister all components
   */
  static unregisterAll() {
    this._types.clear();
  }

  /**
   * Checks if a custom component with a given name is registered.
   * @param name The name of the custom component.
   * @returns True if the custom component is registered, otherwise false.
   */
  static isRegistered(name) {
    return this._types.has(name);
  }

  /**
   * Gets the names of the registered custom components.
   */
  static get names() {
    return Array.from(this._types.keys());
  }

  /**
   * Gets the registered custom components.
   */
  static get values() {
    return Array.from(this._types.values());
  }

  /**
   * Gets all attributes of all custom components.
   */
  static get attributes() {
    return this.values.reduce((p, c) => p.concat(c.attributes), []);
  }
}
_CustomComponent = CustomComponent;
_defineProperty(CustomComponent, "_types", new Map());